(function () {
  'use strict';

  var KACHING_LINE_PROPS = { _kaching_cart: '{"isUpsellToggle":true}' };

  function cartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    if (window.Theme && window.Theme.routes && window.Theme.routes.root_url) {
      return window.Theme.routes.root_url;
    }
    return '/';
  }

  function getCart() {
    return fetch(cartRoot() + 'cart.js', {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    }).then(function (r) {
      return r.json();
    });
  }

  /** Add-on block in the same product area as the main form (Pixel Union nests form in .product). */
  function getAddonRootForForm(form) {
    var productArea = form.closest('.product');
    if (productArea) {
      var inProduct = productArea.querySelector('[data-nw-service-addon]');
      if (inProduct) return inProduct;
    }
    var sectionEl = form.closest('section');
    if (sectionEl) {
      var inSection = sectionEl.querySelector('[data-nw-service-addon]');
      if (inSection) return inSection;
    }
    var shopSection = form.closest('.shopify-section, [id^="shopify-section"]');
    if (shopSection) {
      return shopSection.querySelector('[data-nw-service-addon]');
    }
    return null;
  }

  function getAddonCopy(addonRoot) {
    var title = addonRoot.getAttribute('data-addon-product-title') || '';
    var price = addonRoot.getAttribute('data-addon-price') || '';
    var descEl = addonRoot.querySelector('[data-nw-service-addon-description]');
    var description = '';
    if (descEl && descEl.textContent) {
      try {
        description = JSON.parse(descEl.textContent.trim());
      } catch (e) {
        description = descEl.textContent.trim();
      }
    }
    if (description === null || typeof description === 'undefined') description = '';
    return { title: title, price: price, description: String(description) };
  }

  function syncHeaderCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(cart.item_count);
    });
  }

  function readProductSettingsScript(form) {
    var sid = form.getAttribute('data-product-form');
    if (!sid) return null;
    var el = document.querySelector('script[data-product-settings-' + sid + ']');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function lineTitleFromAddResponse(data) {
    if (!data) return '';
    if (data.title) return data.title;
    if (data.product_title) return data.product_title;
    if (data.items && data.items[0] && (data.items[0].title || data.items[0].product_title)) {
      return data.items[0].title || data.items[0].product_title;
    }
    return '';
  }

  function setThemeLoading(form, loading) {
    var scope = form.closest('.product') || form.closest('[id^="shopify-section"]') || document.body;
    scope.querySelectorAll('.add-to-cart').forEach(function (el) {
      if (loading) el.classList.add('loading');
      else el.classList.remove('loading');
    });
  }

  function afterCartSuccessRedirect() {
    var root = cartRoot();
    return getCart().then(function (cart) {
      syncHeaderCartCount(cart);
      window.location.href = root + 'cart';
    });
  }

  /** Match Pixel Union theme: inline message + cart:count, or redirect when cartRedirect is on. */
  function themeInlineAjaxSuccess(form, mainRes, settings) {
    settings = settings || readProductSettingsScript(form);
    var title = lineTitleFromAddResponse(mainRes);
    var scope = form.closest('.product') || form.closest('[id^="shopify-section"]') || document.body;
    scope.querySelectorAll('.add-to-cart').forEach(function (el) {
      el.classList.remove('loading');
    });
    var msgHtml =
      settings && settings.successMessage
        ? settings.successMessage.split('** product **').join(title)
        : '';

    var productFormWrap = form.closest('.product-form');
    if (productFormWrap && msgHtml) {
      var pm = productFormWrap.querySelector('[data-product-message]');
      if (pm) {
        pm.classList.remove('error');
        pm.classList.add('success');
        pm.innerHTML = msgHtml;
      }
    }
    var btn = form.querySelector('.add-to-cart__button');
    if (btn && settings && !(window.Modernizr && window.Modernizr.cssanimations)) {
      btn.value = settings.addToCartText;
    }
    return getCart().then(function (cart) {
      syncHeaderCartCount(cart);
      document.dispatchEvent(
        new CustomEvent('cart:count', {
          detail: { count: cart.item_count },
        })
      );
    });
  }

  function finishStorefrontProductAdd(form, mainRes) {
    var settings = readProductSettingsScript(form);
    if (settings && settings.cartRedirect) {
      return afterCartSuccessRedirect();
    }
    return themeInlineAjaxSuccess(form, mainRes, settings);
  }

  function postFormData(formData) {
    var root = cartRoot();
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function postAddonItem(variantId) {
    var root = cartRoot();
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: KACHING_LINE_PROPS,
          },
        ],
      }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function addMainThenOptionalAddon(formData, addonVariantId, includeAddon, resolve, reject, formEl) {
    return postFormData(formData)
      .then(function (mainRes) {
        if (!includeAddon) return mainRes;
        return postAddonItem(addonVariantId).then(function () {
          return mainRes;
        });
      })
      .then(function (mainRes) {
        if (typeof resolve === 'function') {
          resolve(mainRes);
          return mainRes;
        }
        return finishStorefrontProductAdd(formEl, mainRes);
      })
      .catch(function (err) {
        if (formEl && typeof resolve !== 'function') {
          setThemeLoading(formEl, false);
          setFormSubmitBusy(formEl, false);
        }
        if (typeof reject === 'function') reject(err);
        else if (typeof console !== 'undefined' && console.error) console.error('NW service add-on:', err);
      });
  }

  function formIsCartAdd(form) {
    try {
      var u = new URL(form.action, window.location.href);
      var path = u.pathname.replace(/\/$/, '');
      return path.endsWith('/cart/add');
    } catch (e) {
      return (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
    }
  }

  function setFormSubmitBusy(form, busy) {
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (btn) btn.disabled = !!busy;
  }

  function isMainAddToCartButton(el) {
    if (!el || !el.closest) return null;
    var btn = el.closest('input.add-to-cart__button, button.add-to-cart__button');
    if (!btn || btn.type !== 'submit') return null;
    var form = btn.closest('form');
    if (!form || !formIsCartAdd(form)) return null;
    if (!form.closest('.product')) return null;
    return btn;
  }

  function ensureUpsellModal() {
    if (document.getElementById('nw-service-addon-upsell-modal')) return;
    var root = document.createElement('div');
    root.id = 'nw-service-addon-upsell-modal';
    root.className = 'nw-service-addon-modal';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="nw-service-addon-modal__backdrop" data-nw-modal-backdrop tabindex="-1"></div>' +
      '<div class="nw-service-addon-modal__panel">' +
      '<p class="nw-service-addon-modal__lead" data-nw-modal-lead></p>' +
      '<div class="nw-service-addon-modal__desc" data-nw-modal-desc hidden></div>' +
      '<div class="nw-service-addon-modal__actions">' +
      '<button type="button" class="nw-service-addon-modal__btn nw-service-addon-modal__btn--primary button" data-nw-modal-add></button>' +
      '<button type="button" class="nw-service-addon-modal__btn nw-service-addon-modal__btn--secondary button" data-nw-modal-no></button>' +
      '</div></div>';
    document.body.appendChild(root);
  }

  function openUpsellModal(copy, onAddBoth, onMainOnly) {
    ensureUpsellModal();
    var root = document.getElementById('nw-service-addon-upsell-modal');
    var lead = root.querySelector('[data-nw-modal-lead]');
    var desc = root.querySelector('[data-nw-modal-desc]');
    var btnAdd = root.querySelector('[data-nw-modal-add]');
    var btnNo = root.querySelector('[data-nw-modal-no]');
    var backdrop = root.querySelector('[data-nw-modal-backdrop]');

    var leadText =
      'Do you want to add ' + (copy.title || 'this service') + ' for ' + (copy.price || '') + '?';
    lead.textContent = leadText;

    if (copy.description) {
      desc.textContent = copy.description;
      desc.removeAttribute('hidden');
    } else {
      desc.textContent = '';
      desc.setAttribute('hidden', 'hidden');
    }

    btnAdd.textContent =
      typeof window.nwServiceAddonStrings === 'object' && window.nwServiceAddonStrings.addBoth
        ? window.nwServiceAddonStrings.addBoth
        : 'Add to cart';
    btnNo.textContent =
      typeof window.nwServiceAddonStrings === 'object' && window.nwServiceAddonStrings.decline
        ? window.nwServiceAddonStrings.decline
        : 'No thank you';

    function finish() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      btnAdd.onclick = null;
      btnNo.onclick = null;
      backdrop.onclick = null;
      document.removeEventListener('keydown', onKey);
    }

    function onKey(ev) {
      if (ev.key === 'Escape') {
        finish();
        onMainOnly();
      }
    }

    btnAdd.onclick = function () {
      finish();
      onAddBoth();
    };
    btnNo.onclick = function () {
      finish();
      onMainOnly();
    };
    backdrop.onclick = function () {
      finish();
      onMainOnly();
    };

    document.addEventListener('keydown', onKey);
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    btnAdd.focus();
  }

  function runInterceptedAdd(form, addonRoot, variantId, includeAddon, resolve, reject) {
    function exec(withAddon) {
      var isThemeSection = typeof resolve !== 'function';
      if (isThemeSection) {
        setFormSubmitBusy(form, true);
        setThemeLoading(form, true);
      }
      addMainThenOptionalAddon(new FormData(form), variantId, withAddon, resolve, reject, form).finally(
        function () {
          if (isThemeSection) {
            setFormSubmitBusy(form, false);
          }
        }
      );
    }

    if (includeAddon) {
      exec(true);
      return;
    }

    openUpsellModal(getAddonCopy(addonRoot), function () {
      exec(true);
    }, function () {
      exec(false);
    });
  }

  /**
   * Pixel Union / startup.js: add-to-cart is handled on button *click* via Shopify.addItemFromForm,
   * not form submit. Capture the click before jQuery so our upsell runs.
   */
  document.addEventListener(
    'click',
    function (e) {
      if (!isMainAddToCartButton(e.target)) return;

      var btn = e.target.closest('input.add-to-cart__button, button.add-to-cart__button');
      var form = btn.closest('form');
      var addonRoot = getAddonRootForForm(form);
      if (!addonRoot) return;

      var checkbox = addonRoot.querySelector('.nw-service-addon__checkbox');
      if (checkbox && checkbox.disabled) return;

      var variantId = addonRoot.getAttribute('data-variant-id');
      if (!variantId) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      runInterceptedAdd(form, addonRoot, variantId, checkbox && checkbox.checked, null, null);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof window.HTMLFormElement)) return;
      if (!formIsCartAdd(form)) return;
      if (form.closest('product-form')) return;

      var addonRoot = getAddonRootForForm(form);
      if (!addonRoot) return;

      var checkbox = addonRoot.querySelector('.nw-service-addon__checkbox');
      if (checkbox && checkbox.disabled) return;

      var variantId = addonRoot.getAttribute('data-variant-id');
      if (!variantId) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      runInterceptedAdd(form, addonRoot, variantId, checkbox && checkbox.checked, null, null);
    },
    true
  );

  document.addEventListener('product-form:cart:request', function (e) {
    var pf = e.target;
    if (!pf || pf.tagName !== 'PRODUCT-FORM') return;
    var form = pf.querySelector('form');
    if (!(form instanceof window.HTMLFormElement) || !formIsCartAdd(form)) return;

    var addonRoot = getAddonRootForForm(form);
    if (!addonRoot) return;

    var checkbox = addonRoot.querySelector('.nw-service-addon__checkbox');
    if (checkbox && checkbox.disabled) return;

    var variantId = addonRoot.getAttribute('data-variant-id');
    if (!variantId) return;

    e.preventDefault();

    var detail = e.detail;
    runInterceptedAdd(
      form,
      addonRoot,
      variantId,
      checkbox && checkbox.checked,
      detail.resolve,
      detail.reject
    );
  });

  document.addEventListener('click', function (e) {
    var infoBtn = e.target.closest('[data-nw-service-addon-info]');
    if (infoBtn) {
      var wrap = infoBtn.closest('.nw-service-addon__tooltip-wrap');
      if (!wrap) return;
      var wasOpen = wrap.classList.contains('is-tooltip-open');
      document.querySelectorAll('.nw-service-addon__tooltip-wrap.is-tooltip-open').forEach(function (w) {
        w.classList.remove('is-tooltip-open');
        var b = w.querySelector('[data-nw-service-addon-info]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        wrap.classList.add('is-tooltip-open');
        infoBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.nw-service-addon__tooltip-wrap')) {
      document.querySelectorAll('.nw-service-addon__tooltip-wrap.is-tooltip-open').forEach(function (w) {
        w.classList.remove('is-tooltip-open');
        var b = w.querySelector('[data-nw-service-addon-info]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
